<template>
    <v-form :ref="get_step_string">
        <div class="row">
            <div class="col-12 pb-0">
                <h1>Select your endpoint</h1>
                <p class="text--black">Activation endpoints are specific locations where we send your custom audience data directly to your chosen cloud provider.
                    This ensures seamless integration with your applications and workflows. Please ensure that the necessary permissions and access are configured at these endpoints to guarantee successful data delivery.
                </p>
                <p>For more information please refer to <a href="https://docs.intuizi.com/knowledge-base/activation/activation-endpoints/" target="_blank">our docs</a>.</p>
            </div>
            <div class="col-12 pt-0" v-if="!is_valid_input">
                <div class="alert alert-danger" role="alert">
                    Selection of the endpoint is required.
                </div>
            </div>
            <div class="col-12 endpoints justify-content-between" v-if="is_loading_completed">
                <div @click="selectPartner(item)" class="endpoint-partner" :class="{'active' : (partner.id === item.id)}" v-for="item in orderedPartners">
                    <a>
                        <img :src="'/img/assets/endpoints/' + item.logo" :alt="item.description">
                    </a>
                </div>
            </div>
            <div class="col-12">
                <EndpointsLoading v-if="!is_loading_completed"></EndpointsLoading>
            </div>
        </div>
    </v-form>
</template>

<script>

import Loading from "../shared/LoadingRow";
import EndpointsLoading from "./partials/EndpointsLoading.vue";

export default {
    name: "ActivationEndpoints",
    components: {
        EndpointsLoading,
        Loading
    },
    props: {
        isScheduler: Boolean,
        step: Number
    },
    data: () => ({
        is_valid_input: true
    }),
    methods: {
        selectPartner(partner) {
            if (partner.id !== this.$store.getters['ActivateAudienceStore/getActivationPartner'].id) {
                this.$store.commit('ActivateAudienceStore/SET_AUDIENCE_INPUTS', [])
                this.$store.commit('ActivateAudienceStore/SET_DATASTREAMS_INPUTS', [])
            }

            this.$store.commit('ActivateAudienceStore/SET_PRICING_MODELS', [])
            this.$store.commit('ActivateAudienceStore/SET_PRICING_MODEL', '')
            this.$store.commit('ActivateAudienceStore/SET_PRICE', '')
            this.$store.commit('ActivateAudienceStore/SET_ACTIVATION_PARTNER', partner)

            this.$store.commit('ActivateAudienceStore/SET_STEP_STATUS', true)

            if (this.isScheduler) {
                this.$store.dispatch('CreateAudienceStore/increaseSchedulerProcessStep')
            } else {
                this.$store.dispatch('ActivateAudienceStore/increaseProcessStep')
            }
        },
        validateForm() {
            if (this.$refs['step_' + this.step].validate() && this.partner.id) {
                this.is_valid_input = true

            } else {
                this.is_valid_input = false
            }

            if (this.is_valid_input) {
                if (this.isScheduler) {
                    this.$store.dispatch('CreateAudienceStore/increaseSchedulerProcessStep')
                } else {
                    this.$store.dispatch('ActivateAudienceStore/increaseProcessStep')
                }
            }
        }
    },
    created() {
        if (this.isScheduler && this.$store.getters['CreateAudienceStore/getSchedulerAudienceType'] === 1) {
            let dataset_types = []
            dataset_types[0] = this.$store.getters['CreateAudienceStore/getAnalysisType'](0).toLowerCase()

            if (this.$store.getters['CreateAudienceStore/getAnalysisType'](1)) {
                dataset_types[1] = this.$store.getters['CreateAudienceStore/getAnalysisType'](1).toLowerCase()
            }

            this.$store.commit('ActivateAudienceStore/SET_ACTIVATION_ANALYSES', dataset_types)
        }
    },
    mounted() {
        if (this.$store.getters['ActivateAudienceStore/getStepStatus']) {
            this.$store.dispatch('ActivateAudienceStore/getActivationPartners')
        }
    },
    computed: {
        orderedPartners: function() {
            return _.orderBy(this.$store.getters['ActivateAudienceStore/getActivationEndpoints'], 'sort_order')
        },
        partner: {
            get() {
                return this.$store.getters['ActivateAudienceStore/getActivationPartner']
            },
            set(value) {
                this.$store.commit('ActivateAudienceStore/SET_ACTIVATION_PARTNER', value)
            }
        },
        is_loading_completed: function () {
            if (this.$store.getters['ActivateAudienceStore/getActivationEndpoints'].length) {
                return true
            }

            return false
        },
        get_step_string() {
            return "step_" + this.step
        }
    },
    watch: {
        //
    }
}
</script>

<style scoped>

</style>